export default {
  // Common
  'sys.common.confirm': '确定',
  'sys.common.cancel': '取消',

  // User Management
  'sys.user.headerTitle': '用户管理',
  'sys.user.action.create': '新建用户',
  'sys.user.action.resetPassword': '重置密码',
  'sys.user.action.view': '查看',
  'sys.user.action.edit': '编辑',
  'sys.user.action.disable': '停用',
  'sys.user.action.enable': '启用',
  'sys.user.column.loginName': '用户名',
  'sys.user.column.name': '昵称',
  'sys.user.column.email': '邮箱',
  'sys.user.column.phone': '手机号',
  'sys.user.column.roleIds': '角色',
  'sys.user.column.loginFlag': '状态',
  'sys.user.column.createdTime': '创建时间',
  'sys.user.column.action': '操作',
  'sys.user.status.enabled': '启用',
  'sys.user.status.disabled': '禁用',
  'sys.user.confirm.disable.title': '确定要停用这个用户吗？',
  'sys.user.confirm.disable.description': '停用后该用户将无法登录系统',
  'sys.user.confirm.enable.title': '确定要启用这个用户吗？',
  'sys.user.confirm.enable.description': '启用后该用户将可以正常登录系统',
  'sys.user.confirm.resetPassword.title':
    '确定要重置选中的 {count} 个用户的密码吗？',
  'sys.user.confirm.resetPassword.description':
    '系统将生成随机新密码，并直接发送到用户绑定邮箱',
  'sys.user.confirm.resetPassword.noEmailDescription':
    '重置后的默认密码为：123456',
  'sys.user.confirm.resetPassword.mixedDescription':
    '检测到 {usersWithEmailCount} 个用户已绑定邮箱，将通过邮件发送随机密码；{usersWithoutEmailCount} 个用户未绑定邮箱，将重置为默认密码：123456',
  'sys.user.confirm.ok': '确定',
  'sys.user.confirm.cancel': '取消',
  'sys.user.message.disable.success': '停用成功',
  'sys.user.message.disable.failed': '停用失败',
  'sys.user.message.enable.success': '启用成功',
  'sys.user.message.enable.failed': '启用失败',
  'sys.user.message.batchDisable.success': '批量停用成功',
  'sys.user.message.batchDisable.failed': '批量停用失败',
  'sys.user.message.resetPassword.warning': '请先选择要重置密码的用户',
  'sys.user.message.resetPassword.success':
    '成功重置 {count} 个用户的密码',
  'sys.user.message.resetPassword.partial':
    '已成功处理 {successCount} 个用户，{failedCount} 个用户重置失败，请稍后重试',
  'sys.user.message.resetPassword.missingLoginName':
    '所选用户缺少登录名，无法重置密码',
  'sys.user.message.resetPassword.failed': '重置密码失败',
  'sys.user.message.create.success': '创建成功',
  'sys.user.message.update.success': '更新成功',
  'sys.user.message.getDetail.failed': '获取用户详情失败',
  'sys.user.message.getRoleList.failed': '获取角色列表失败',
  'sys.user.modal.create.title': '新建用户',
  'sys.user.modal.edit.title': '编辑用户',
  'sys.user.modal.detail.title': '用户详情',
  'sys.user.modal.detail.close': '关闭',
  'sys.user.detail.label.loginName': '用户名',
  'sys.user.detail.label.name': '昵称',
  'sys.user.detail.label.status': '状态',
  'sys.user.detail.label.email': '邮箱',
  'sys.user.detail.label.phone': '手机号',
  'sys.user.detail.label.roleIds': '角色',
  'sys.user.detail.label.createdTime': '创建时间',
  'sys.user.detail.label.updatedTime': '更新时间',

  // Dictionary Management
  'sys.dict.breadcrumb.root': '字典管理',
  'sys.dict.breadcrumb.rootDict': '根字典',
  'sys.dict.headerTitle': '字典管理',
  'sys.dict.action.create': '新增字典',
  'sys.dict.action.clearCache': '清空缓存',
  'sys.dict.action.batchDelete': '批量删除',
  'sys.dict.action.config': '配置',
  'sys.dict.action.edit': '编辑',
  'sys.dict.action.view': '查看',
  'sys.dict.action.delete': '删除',
  'sys.dict.column.type': '字典类型',
  'sys.dict.column.label': '字典名称',
  'sys.dict.column.value': '字典值',
  'sys.dict.column.langLabel': '多语言',
  'sys.dict.column.description': '描述',
  'sys.dict.column.sort': '排序',
  'sys.dict.column.action': '操作',
  'sys.dict.confirm.delete.title': '确认删除',
  'sys.dict.confirm.delete.content': '确定要删除字典 "{label}" 吗？',
  'sys.dict.confirm.batchDelete.title': '确认批量删除',
  'sys.dict.confirm.batchDelete.content': '确定要删除选中的 {count} 个字典吗？',
  'sys.dict.confirm.clearCache.title': '确认清空缓存',
  'sys.dict.confirm.clearCache.content': '确定要清空所有字典缓存吗？',
  'sys.dict.message.delete.success': '删除成功',
  'sys.dict.message.delete.failed': '删除失败',
  'sys.dict.message.batchDelete.warning': '请选择要删除的字典',
  'sys.dict.message.batchDelete.success': '批量删除成功',
  'sys.dict.message.batchDelete.failed': '批量删除失败',
  'sys.dict.message.clearCache.success': '缓存清空成功',
  'sys.dict.message.clearCache.failed': '缓存清空失败',
  'sys.dict.message.create.success': '创建字典成功',
  'sys.dict.message.create.failed': '创建字典失败',
  'sys.dict.message.update.success': '更新字典成功',
  'sys.dict.message.update.failed': '更新字典失败',
  'sys.dict.message.multiLang.success': '多语言配置已保存',
  'sys.dict.modal.detail.title': '字典详情',
  'sys.dict.modal.create.title': '新增字典',
  'sys.dict.modal.edit.title': '编辑字典',
  'sys.dict.modal.config.title': '{dict} - 字典配置',
  'sys.dict.config.column.label': '标签',
  'sys.dict.config.column.value': '值',
  'sys.dict.config.column.langLabel': '多语言标签',
  'sys.dict.message.config.notFound': '未找到对应的字典类型配置',
  'sys.dict.message.config.loadFailed': '获取字典配置失败',
  'sys.dict.form.type.label': '字典类型',
  'sys.dict.form.type.placeholder': '请输入字典类型',
  'sys.dict.form.type.required': '请输入字典类型',
  'sys.dict.form.type.maxLength': '字典类型不能超过100个字符',
  'sys.dict.form.label.label': '字典名称',
  'sys.dict.form.label.placeholder': '请输入字典名称',
  'sys.dict.form.label.required': '请输入字典名称',
  'sys.dict.form.label.maxLength': '字典名称不能超过100个字符',
  'sys.dict.form.value.label': '字典值',
  'sys.dict.form.value.placeholder': '请输入字典值',
  'sys.dict.form.value.required': '请输入字典值',
  'sys.dict.form.value.maxLength': '字典值不能超过100个字符',
  'sys.dict.form.sort.label': '排序',
  'sys.dict.form.sort.placeholder': '请输入排序值',
  'sys.dict.form.multiLang.label': '多语言配置',
  'sys.dict.form.multiLang.button': '配置多语言',
  'sys.dict.form.description.label': '描述',
  'sys.dict.form.description.placeholder': '请输入描述',
  'sys.dict.form.description.maxLength': '描述不能超过500个字符',
  'sys.dict.form.submit.create': '创建',
  'sys.dict.form.submit.update': '更新',
  'sys.dict.form.submit.cancel': '取消',
  'sys.dict.multiLang.modal.title': '多语言配置',
  'sys.dict.multiLang.modal.ok': '保存',
  'sys.dict.multiLang.modal.cancel': '取消',
  'sys.dict.multiLang.action.add': '添加语言配置',
  'sys.dict.multiLang.select.placeholder': '选择语言',
  'sys.dict.multiLang.input.placeholder': '请输入该语言的值',
  'sys.dict.multiLang.language.zh': '中文简体',
  'sys.dict.multiLang.language.en': 'English',
  'sys.dict.multiLang.message.keepOne': '至少保留一个语言配置',
  'sys.dict.multiLang.message.fillAllValues': '请完善所有语言配置的值',
  'sys.dict.multiLang.message.duplicateLanguage': '存在重复的语言配置，请检查',
  'sys.dict.itemForm.modal.create.title': '新增字典项',
  'sys.dict.itemForm.modal.edit.title': '编辑字典项',
  'sys.dict.itemForm.label.required': '请输入标签',
  'sys.dict.itemForm.label.placeholder': '请输入标签',
  'sys.dict.itemForm.label.maxLength': '标签长度不能超过100个字符',
  'sys.dict.itemForm.value.required': '请输入值',
  'sys.dict.itemForm.value.placeholder': '请输入值',
  'sys.dict.itemForm.value.maxLength': '值长度不能超过100个字符',
  'sys.dict.itemForm.multiLang.button': '配置多语言标签',
  'sys.dict.itemForm.message.sortFallback': '获取排序值失败，使用默认值',
  'sys.dict.itemForm.message.create.success': '新增成功',
  'sys.dict.itemForm.message.create.failed': '新增失败',
  'sys.user.title': '用户管理',
  'sys.role.title': '角色管理',
  'sys.menu.title': '菜单管理',
  'sys.dict.title': '字典管理',
  'sys.upload.title': '文件管理',

  // Role Management
  'sys.role.headerTitle': '角色管理',
  'sys.role.action.create': '新建角色',
  'sys.role.action.view': '查看',
  'sys.role.action.edit': '编辑',
  'sys.role.action.auth': '授权',
  'sys.role.action.delete': '删除',
  'sys.role.column.name': '角色名称',
  'sys.role.column.enname': '英文名称',
  'sys.role.column.roleType': '角色编码',
  'sys.role.column.sort': '排序',
  'sys.role.column.remarks': '描述',
  'sys.role.column.useable': '状态',
  'sys.role.column.action': '操作',
  'sys.role.status.enabled': '启用',
  'sys.role.status.disabled': '禁用',
  'sys.role.confirm.delete.title': '确定要删除这个角色吗？',
  'sys.role.confirm.batchDelete.title': '确定要批量删除选中的角色吗？',
  'sys.role.message.delete.success': '删除成功',
  'sys.role.message.delete.failed': '删除失败',
  'sys.role.message.batchDelete.success': '批量删除成功',
  'sys.role.message.batchDelete.failed': '批量删除失败',
  'sys.role.message.create.success': '创建成功',
  'sys.role.message.update.success': '更新成功',
  'sys.role.message.auth.success': '授权成功',
  'sys.role.modal.create.title': '新建角色',
  'sys.role.modal.edit.title': '编辑角色',
  'sys.role.modal.detail.title': '角色详情',
  'sys.role.modal.auth.title': '角色菜单授权',
  'sys.role.detail.label.name': '角色名称',
  'sys.role.detail.label.enname': '英文名称',
  'sys.role.detail.label.roleType': '角色编码',
  'sys.role.detail.label.sort': '排序',
  'sys.role.detail.label.useable': '状态',
  'sys.role.detail.label.remarks': '描述',
  'sys.role.table.alert.selected': '已选择',
  'sys.role.table.alert.items': '项',
  'sys.role.table.alert.deselect': '取消选择',
  'sys.role.table.alert.batchDelete': '批量删除',
  'sys.role.form.name.label': '角色名称',
  'sys.role.form.name.placeholder': '请输入角色名称',
  'sys.role.form.name.required': '请输入角色名称',
  'sys.role.form.name.length': '角色名称长度为2-50个字符',
  'sys.role.form.enname.label': '英文名称',
  'sys.role.form.enname.placeholder': '请输入英文名称',
  'sys.role.form.enname.required': '请输入英文名称',
  'sys.role.form.enname.length': '英文名称长度为2-50个字符',
  'sys.role.form.sort.label': '排序',
  'sys.role.form.sort.placeholder': '请输入排序值',
  'sys.role.form.sort.required': '请输入排序值',
  'sys.role.form.sort.pattern': '排序值必须为正整数',
  'sys.role.form.useable.label': '状态',
  'sys.role.form.useable.placeholder': '请选择状态',
  'sys.role.form.useable.required': '请选择状态',
  'sys.role.form.useable.enabled': '启用',
  'sys.role.form.useable.disabled': '禁用',
  'sys.role.form.remarks.label': '描述',
  'sys.role.form.remarks.placeholder': '请输入角色描述',
  'sys.role.form.submit.create': '创建',
  'sys.role.form.submit.update': '更新',
  'sys.role.form.submit.cancel': '取消',
  'sys.role.message.create.failed': '创建失败',
  'sys.role.message.update.failed': '更新失败',
  'sys.role.auth.label.name': '角色名称：',
  'sys.role.auth.label.menu': '菜单权限：',
  'sys.role.auth.message.incomplete': '角色信息不完整',
  'sys.role.auth.message.failed': '保存失败',
  'sys.role.auth.message.getMenuTree.failed': '获取菜单数据失败',
  'sys.role.auth.message.getRoleMenuIds.failed': '获取角色菜单权限失败',
  'sys.role.auth.button.cancel': '取消',
  'sys.role.auth.button.save': '保存',

  // Menu Management
  'sys.menu.headerTitle': '菜单管理',
  'sys.menu.action.create': '新建菜单',
  'sys.menu.action.createChild': '新建',
  'sys.menu.action.edit': '编辑',
  'sys.menu.action.view': '查看',
  'sys.menu.action.delete': '删除',
  'sys.menu.column.name': '菜单名称',
  'sys.menu.column.enName': '英文名称',
  'sys.menu.column.type': '类型',
  'sys.menu.column.icon': '图标',
  'sys.menu.column.href': '链接',
  'sys.menu.column.permission': '权限标识',
  'sys.menu.column.isShow': '是否显示',
  'sys.menu.column.sort': '排序',
  'sys.menu.column.action': '操作',
  'sys.menu.type.menu': '菜单',
  'sys.menu.type.button': '按钮',
  'sys.menu.status.show': '显示',
  'sys.menu.status.hide': '隐藏',
  'sys.menu.confirm.delete.title': '确定要删除这个菜单吗？',
  'sys.menu.message.delete.success': '删除成功',
  'sys.menu.message.delete.failed': '删除失败',
  'sys.menu.message.batchDelete.success': '批量删除成功',
  'sys.menu.message.batchDelete.failed': '批量删除失败',
  'sys.menu.message.create.success': '创建成功',
  'sys.menu.message.create.failed': '创建菜单失败',
  'sys.menu.message.update.success': '更新成功',
  'sys.menu.message.update.failed': '更新菜单失败',
  'sys.menu.modal.create.title': '新建菜单',
  'sys.menu.modal.edit.title': '编辑菜单',
  'sys.menu.modal.detail.title': '菜单详情',
  'sys.menu.form.name.label': '菜单名称',
  'sys.menu.form.name.placeholder': '请输入菜单名称',
  'sys.menu.form.name.required': '请输入菜单名称',
  'sys.menu.form.enName.label': '英文名称',
  'sys.menu.form.enName.placeholder': '请输入英文名称',
  'sys.menu.form.parentMenu.label': '上级菜单',
  'sys.menu.form.parentMenu.placeholder': '请选择上级菜单',
  'sys.menu.form.parentMenu.required': '请选择上级菜单',
  'sys.menu.form.parentMenu.tip': '可选择任意层级的菜单作为上级菜单',
  'sys.menu.form.icon.label': '图标',
  'sys.menu.form.icon.placeholder': '请输入或选择图标',
  'sys.menu.form.path.label': '路由地址',
  'sys.menu.form.path.placeholder': '请输入路由地址',
  'sys.menu.form.perms.label': '权限标识',
  'sys.menu.form.perms.placeholder': '请输入权限标识',
  'sys.menu.form.perms.add': '新增',
  'sys.menu.form.perms.edit': '编辑',
  'sys.menu.form.perms.delete': '删除',
  'sys.menu.form.status.label': '是否显示',
  'sys.menu.form.status.show': '显示',
  'sys.menu.form.status.hide': '隐藏',
  'sys.menu.form.sort.label': '显示排序',
  'sys.menu.form.sort.required': '请输入显示排序',
  'sys.menu.form.message.noUrl': '无法获取菜单URL，请确保已正确选择上级菜单',
  'sys.menu.detail.label.name': '菜单名称',
  'sys.menu.detail.label.enName': '英文名称',
  'sys.menu.detail.label.type': '类型',
  'sys.menu.detail.label.icon': '图标',
  'sys.menu.detail.label.href': '链接',
  'sys.menu.detail.label.permission': '权限标识',
  'sys.menu.detail.label.isShow': '是否显示',
  'sys.menu.detail.label.sort': '排序',
  'sys.menu.detail.label.remarks': '备注',

  // File Upload Management
  'sys.upload.headerTitle': '文件管理',
  'sys.upload.action.upload': '上传文件',
  'sys.upload.action.refresh': '刷新',
  'sys.upload.action.copy': '复制',
  'sys.upload.action.delete': '删除',
  'sys.upload.column.name': '文件名',
  'sys.upload.column.type': '类型',
  'sys.upload.column.size': '大小',
  'sys.upload.column.lastModified': '修改时间',
  'sys.upload.column.action': '操作',
  'sys.upload.type.file': '文件',
  'sys.upload.type.folder': '文件夹',
  'sys.upload.bucket.label': '存储桶:',
  'sys.upload.bucket.data': 'data',
  'sys.upload.bucket.public': 'public',
  'sys.upload.tree.title': '目录结构',
  'sys.upload.tree.root': '根目录',
  'sys.upload.table.title': '当前目录:',
  'sys.upload.table.total': '共 {total} 个文件',
  'sys.upload.modal.title': '上传文件',
  'sys.upload.modal.uploadTo': '上传到:',
  'sys.upload.modal.dragHint': '点击或拖拽文件到此区域上传',
  'sys.upload.modal.dragHintSub': '支持单个或批量上传文件',
  'sys.upload.modal.uploading': '上传中...',
  'sys.upload.confirm.delete.title': '确认删除',
  'sys.upload.confirm.delete.content': '确定要删除文件 "{fileName}" 吗？',
  'sys.upload.message.delete.success': '文件删除成功',
  'sys.upload.message.delete.failed': '文件删除失败',
  'sys.upload.message.upload.success': '文件上传成功',
  'sys.upload.message.upload.failed': '文件上传失败',
  'sys.upload.message.copy.success': '访问地址已复制到剪贴板',
  'sys.upload.message.copy.failed': '复制失败，请手动复制',
  'sys.upload.message.getFiles.failed': '获取文件列表失败',
  'sys.upload.message.initTree.failed': '初始化目录树失败',
  'sys.upload.message.getViewUrl.failed': '获取预览地址配置失败',
};
